var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"background-container",style:(_vm.$vuetify.breakpoint.name != 'xs' ? _vm.backgroundStyle : _vm.XSbackgroundStyle)},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }